import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { subscribeWithSelector } from "zustand/middleware";
import sqliteStorage from "./sqliteStorage";

const DEFAULTS = {
  statesData: null,
  countriesData: null,
  posScanConfigurations: null,
  registrationTypes: null,
  feedbackJson: null,
  customerConfigs: null,
};

const useReferenceStore = create(
  subscribeWithSelector(
    persist(
      (set, get) => ({
        ...DEFAULTS,
        _hydrated: false,

        // Actions
        setStatesData: (data) => set({ statesData: data }),
        setCountriesData: (data) => set({ countriesData: data }),
        setPosScanConfigurations: (config) => set({ posScanConfigurations: config }),
        setRegistrationTypes: (types) => set({ registrationTypes: types }),
        setFeedbackJson: (json) => set({ feedbackJson: json }),
        setCustomerConfigs: (configs) => set({ customerConfigs: configs }),

        clearReference: () => set({ ...DEFAULTS }),
      }),
      {
        name: "referenceStore",
        storage: createJSONStorage(() => sqliteStorage),
        skipHydration: true,
        partialize: (state) => ({
          statesData: state.statesData,
          countriesData: state.countriesData,
          posScanConfigurations: state.posScanConfigurations,
          registrationTypes: state.registrationTypes,
          feedbackJson: state.feedbackJson,
          customerConfigs: state.customerConfigs,
        }),
        merge: (persisted, current) => ({
          ...current,
          ...DEFAULTS,
          ...(persisted || {}),
          _hydrated: true,
        }),
      }
    )
  )
);

export default useReferenceStore;
